import React from 'react';

export function LimitsPanel({ rateLimit, resourceLimits, expiresAt, cors, onChange }) {
  function update(patch) {
    onChange(patch);
  }

  return (
    <div className="panel-section">
      <div className="field-grid">
        <label>
          Rate limit - max requests
          <input
            type="number"
            min={1}
            value={rateLimit.max}
            onChange={(e) => update({ rateLimit: { ...rateLimit, max: Number(e.target.value) } })}
          />
        </label>
        <label>
          Rate limit - window (seconds)
          <input
            type="number"
            min={1}
            value={rateLimit.windowMs / 1000}
            onChange={(e) => update({ rateLimit: { ...rateLimit, windowMs: Number(e.target.value) * 1000 } })}
          />
        </label>
        <label>
          Timeout (ms)
          <input
            type="number"
            min={100}
            max={15000}
            value={resourceLimits.timeoutMs}
            onChange={(e) => update({ resourceLimits: { ...resourceLimits, timeoutMs: Number(e.target.value) } })}
          />
        </label>
        <label>
          Memory (MB)
          <input
            type="number"
            min={8}
            max={256}
            value={resourceLimits.memoryMb}
            onChange={(e) => update({ resourceLimits: { ...resourceLimits, memoryMb: Number(e.target.value) } })}
          />
        </label>
        <label>
          Expires at
          <input
            type="date"
            value={expiresAt ? expiresAt.slice(0, 10) : ''}
            onChange={(e) => update({ expiresAt: new Date(e.target.value).toISOString() })}
          />
        </label>
        <label>
          CORS allowed origins (comma-separated, * for any)
          <input
            value={cors.allowedOrigins.join(', ')}
            onChange={(e) =>
              update({
                cors: { allowedOrigins: e.target.value.split(',').map((s) => s.trim()).filter(Boolean) },
              })
            }
          />
        </label>
      </div>
    </div>
  );
}
